// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

import DriveEtaIcon from "@mui/icons-material/DriveEta";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Link, useNavigate } from "react-router-dom";
import DataTable from "examples/Tables/DataTable";

// MUI components
import IconButton from "@mui/material/IconButton";
import AddIcon from "@mui/icons-material/Add";
import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";

// Data
import tripMonitorAuthorTable from "layouts/tables/data/tripMonitorAuthorTable";
import { useCallback, useEffect, useState } from "react";
import { getDatabase, ref, onValue, set, update, get } from "firebase/database";
import { dataBase, db } from "../../firebase";
import apiClient from "../../Utils/apiClient";
import { useMaterialUIController, setMiniSidenav, setOpenConfigurator } from "context";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Box,
  Button,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import moment from "moment";
import { showStyledToast } from "components/toastAlert";
import { OpenInFull } from "@mui/icons-material";
import ImageModal from "components/ImageModal";
import { getCurrentAdminState } from "Utils/Functions";
import EmptyData from "components/EmptyData";
import { useSelector } from "react-redux";
import SosSection from "components/SosSection";

function TripMonitor() {
  const navigate = useNavigate();
  const allData = useSelector((state) => state.data.allData);
  const getUserState = useSelector((state) => state?.data?.getUserState);
  const [controller, dispatch] = useMaterialUIController();

  const [rows, setRows] = useState([]);
  const { columns } = tripMonitorAuthorTable();
  const { loggedIn } = controller;

  const [searchTxt, setSearchText] = useState("");
  const [search, setSearch] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [onClickImageData, setOnClickImageData] = useState("");
  const [checkSuperAdmin, setCheckSuperAdmin] = useState(null);
  const [adminState, setAdminState] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const handleImageClick = (url) => {
    setIsModalOpen(true);
    setOnClickImageData(url);
  };
  const onClose = () => {
    setIsModalOpen(false);
  };

  const getData = async () => {
    const getAdminData = JSON.parse(localStorage.getItem("user"));
    const getAdminState = getAdminData?.state;
    const useradmin = getAdminData?.superAdmin;
    setCheckSuperAdmin(useradmin);
    setAdminState(getAdminState);
    setLoading(true);
    setRows([]);
        try {
      const { default: apiClient } = await import("Utils/apiClient");
      const res = await apiClient.get('/users?limit=2000');
      let allUsers = res?.data || [];
      if (allUsers.data) allUsers = allUsers.data;
      
      const data = {};
      allUsers.forEach(u => {
        if (u && u._id) data[u._id] = u;
      });
      
      const newRows = [];
        let index = 0;

        for (const key in data) {
          if (data.hasOwnProperty(key)) {
            const user = data[key];

            // Check if useradmin is true, if so, show all trip data
            if (useradmin) {
              if (
                (useradmin && getUserState === "") ||
                (useradmin && getUserState === "All State")
              ) {
                const { ShortDistance_Escort, UserTour } = user;
                if (allData) {
                  // Combine Long Distance Trips
                  for (const longKey in UserTour) {
                    const longTrip = UserTour[longKey];

                    // console.log("longTrip", longTrip);
                    index += 1;
                    newRows.push({
                      Sr: index,
                      Name: user.userName,
                      Email: user?.userEmail,
                      Mobile: user?.userPhone,

                      VehicleReg: longTrip.regNo || "N/A",
                      VehicleImage: (
                        <img
                          onClick={() => handleImageClick(user.userImage)}
                          src={user.userImage}
                          alt="vehicle"
                          style={{ width: "50px", height: "50px", borderRadius: "50%" }}
                        />
                      ),
                      State: user?.state || "Unknown",
                      TripDate: longTrip.selectedDate,
                      IsMoving: (() => {
                        if (longTrip.Trip_Status === "Moving") {
                          return (
                            <Button
                              className="text-white"
                              variant="contained"
                              sx={{ backgroundColor: "green", color: "white" }}
                            >
                              Running
                            </Button>
                          );
                        } else if (longTrip.Trip_Status === "Arrived") {
                          return (
                            <Button
                              variant="contained"
                              className="text-black"
                              sx={{ backgroundColor: "yellow", color: "white" }}
                            >
                              Arrived
                            </Button>
                          );
                        } else {
                          return (
                            <Button
                              variant="contained"
                              className="text-white"
                              sx={{ backgroundColor: "red", color: "white" }}
                            >
                              Stopped
                            </Button>
                          );
                        }
                      })(),
                      TripType: <h5>Long Distance</h5>,
                      StartRide: longTrip.curruntLocation,
                      EndRide: longTrip.finalDestination,
                    });
                  }

                  // Combine Short Distance Trips
                  for (const shortKey in ShortDistance_Escort) {
                    const shortTrip = ShortDistance_Escort[shortKey];
                    const stops = shortTrip.stops;
                    let showStopLatitude;
                    let showStopLongitude;

                    for (const key in stops) {
                      if (stops.hasOwnProperty(key)) {
                        const stop = stops[key];
                        showStopLatitude = stop.stopLatitude;
                        showStopLongitude = stop.stopLongitude;
                        // console.log("Stop latitude:", stop.stopLatitude);
                        // console.log("Stop longitude:", stop.stopLongitude);
                      }
                    }

                    // console.log("showStopLatitude", showStopLatitude);
                    // console.log("showStopLongitude", showStopLongitude);

                    index += 1;
                    newRows.push({
                      Sr: index,
                      Name: user.userName,
                      Email: user?.userEmail,
                      Mobile: user?.userPhone,
                      VehicleReg: shortTrip.regNo || "N/A",
                      VehicleImage: (
                        <img
                          onClick={() => handleImageClick(shortTrip.imgVehicle)}
                          src={shortTrip.imgVehicle}
                          alt="vehicle"
                          style={{ width: "50px", height: "50px", borderRadius: "50%" }}
                        />
                      ),
                      State: user?.state || "Unknown",
                      TripDate: shortTrip.ArrivalDate,
                      IsMoving: (() => {
                        if (shortTrip.Trip_Status === "Moving") {
                          return (
                            <Button
                              variant="contained"
                              className="text-white"
                              sx={{ backgroundColor: "green", color: "white" }}
                            >
                              Running
                            </Button>
                          );
                        } else if (shortTrip.Trip_Status === "Arrived") {
                          return (
                            <Button
                              variant="contained"
                              className="text-black"
                              sx={{ backgroundColor: "yellow", color: "white" }}
                            >
                              Arrived
                            </Button>
                          );
                        } else {
                          return (
                            <Button
                              variant="contained"
                              className="text-white"
                              sx={{ backgroundColor: "red", color: "white" }}
                            >
                              Stopped
                            </Button>
                          );
                        }
                      })(),
                      TripTime: shortTrip.TripTime,
                      TripEndTime: shortTrip?.ArrivalTime || "N/A",
                      TripType: <h5>Short Distance</h5>,
                      StartRide: (
                        <Link
                          to={`/locateSos/${shortTrip.LiveLatitude}/${shortTrip.LiveLongitude}`}
                        >
                          Track
                        </Link>
                      ),
                      EndRide: (
                        <Link to={`/locateSos/${showStopLatitude}/${showStopLongitude}`}>
                          Track
                        </Link>
                      ),
                    });
                  }
                }
              } else {
                if (user?.state === getUserState) {
                  const { ShortDistance_Escort, UserTour } = user;
                  if (allData) {
                    // Combine Long Distance Trips
                    for (const longKey in UserTour) {
                      const longTrip = UserTour[longKey];
                      index += 1;
                      newRows.push({
                        Sr: index,
                        Name: user.userName,
                        Email: user?.userEmail,
                        Phone: user?.userPhone,
                        VehicleReg: longTrip.regNo || "N/A",
                        State: user?.state || "unknown",
                        VehicleImage: (
                          <img
                            onClick={() => handleImageClick(user.userImage)}
                            src={user.userImage}
                            alt="vehicle"
                            style={{ width: "50px", height: "50px", borderRadius: "50%" }}
                          />
                        ),
                        State: user?.state || "Unknown",
                        TripDate: longTrip.selectedDate,
                        IsMoving: (() => {
                          if (longTrip.Trip_Status === "Moving") {
                            return (
                              <Button
                                className="text-white"
                                variant="contained"
                                sx={{ backgroundColor: "green", color: "white" }}
                              >
                                Running
                              </Button>
                            );
                          } else if (longTrip.Trip_ === "Arrived") {
                            return (
                              <Button
                                variant="contained"
                                className="text-black"
                                sx={{ backgroundColor: "yellow", color: "white" }}
                              >
                                Arrived
                              </Button>
                            );
                          } else {
                            return (
                              <Button
                                variant="contained"
                                className="text-white"
                                sx={{ backgroundColor: "red", color: "white" }}
                              >
                                Stopped
                              </Button>
                            );
                          }
                        })(),
                        TripType: <h5>Long Distance</h5>,
                        StartRide: longTrip.curruntLocation,
                        EndRide: longTrip.finalDestination,
                      });
                    }

                    // Combine Short Distance Trips
                    for (const shortKey in ShortDistance_Escort) {
                      const shortTrip = ShortDistance_Escort[shortKey];
                      const stops = shortTrip.stops;
                      let showStopLatitude;
                      let showStopLongitude;

                      for (const key in stops) {
                        if (stops.hasOwnProperty(key)) {
                          const stop = stops[key];
                          showStopLatitude = stop.stopLatitude;
                          showStopLongitude = stop.stopLongitude;
                          // console.log("Stop latitude:", stop.stopLatitude);
                          // console.log("Stop longitude:", stop.stopLongitude);
                        }
                      }

                      // console.log("showStopLatitude", showStopLatitude);
                      // console.log("showStopLongitude", showStopLongitude);

                      index += 1;
                      newRows.push({
                        Sr: index,
                        Name: user.userName,
                        Email: user?.userEmail,
                        Phone: user?.userPhone,
                        VehicleReg: shortTrip.regNo || "N/A",
                        VehicleImage: (
                          <img
                            onClick={() => handleImageClick(shortTrip.imgVehicle)}
                            src={shortTrip.imgVehicle}
                            alt="vehicle"
                            style={{ width: "50px", height: "50px", borderRadius: "50%" }}
                          />
                        ),
                        State: user?.state || "Unknown",
                        TripDate: shortTrip.ArrivalDate,
                        IsMoving: (() => {
                          if (shortTrip.Trip_Status === "Moving") {
                            return (
                              <Button
                                variant="contained"
                                className="text-white"
                                sx={{ backgroundColor: "green", color: "white" }}
                              >
                                Running
                              </Button>
                            );
                          } else if (shortTrip.Trip_Status === "Arrived") {
                            return (
                              <Button
                                variant="contained"
                                className="text-black"
                                sx={{ backgroundColor: "yellow", color: "white" }}
                              >
                                Arrived
                              </Button>
                            );
                          } else {
                            return (
                              <Button
                                variant="contained"
                                className="text-white"
                                sx={{ backgroundColor: "red", color: "white" }}
                              >
                                Stopped
                              </Button>
                            );
                          }
                        })(),
                        TripTime: shortTrip.TripTime,
                        TripEndTime: shortTrip?.ArrivalTime || "N/A",
                        TripType: <h5>Short Distance</h5>,
                        StartRide: (
                          <Link
                            to={`/locateSos/${shortTrip.LiveLatitude}/${shortTrip.LiveLongitude}`}
                          >
                            Track
                          </Link>
                        ),
                        EndRide: (
                          <Link to={`/locateSos/${showStopLatitude}/${showStopLongitude}`}>
                            Track
                          </Link>
                        ),
                      });
                    }
                  }
                }
              }
            } else {
              // If useradmin is false, check the state and only show matching state data
              if (user?.state === getAdminState) {
                const { ShortDistance_Escort, UserTour } = user;
                if (allData) {
                  // Combine Long Distance Trips
                  for (const longKey in UserTour) {
                    const longTrip = UserTour[longKey];
                    index += 1;
                    newRows.push({
                      Sr: index,
                      Name: user.userName,
                      Email: user?.userEmail,
                      Mobile: user?.userPhone,
                      VehicleReg: longTrip.regNo || "N/A",
                      State: user?.state || "unknown",
                      VehicleImage: (
                        <img
                          onClick={() => handleImageClick(user.userImage)}
                          src={user.userImage}
                          alt="vehicle"
                          style={{ width: "50px", height: "50px", borderRadius: "50%" }}
                        />
                      ),
                      State: user?.state || "Unknown",
                      TripDate: longTrip.selectedDate,
                      IsMoving: (() => {
                        if (longTrip.Trip_Status === "Moving") {
                          return (
                            <Button
                              className="text-white"
                              variant="contained"
                              sx={{ backgroundColor: "green", color: "white" }}
                            >
                              Running
                            </Button>
                          );
                        } else if (longTrip.Trip_Status === "Arrived") {
                          return (
                            <Button
                              variant="contained"
                              className="text-black"
                              sx={{ backgroundColor: "yellow", color: "white" }}
                            >
                              Arrived
                            </Button>
                          );
                        } else {
                          return (
                            <Button
                              variant="contained"
                              className="text-white"
                              sx={{ backgroundColor: "red", color: "white" }}
                            >
                              Stopped
                            </Button>
                          );
                        }
                      })(),
                      TripType: <h5>Long Distance</h5>,
                      StartRide: longTrip.curruntLocation,
                      EndRide: longTrip.finalDestination,
                    });
                  }

                  // Combine Short Distance Trips
                  for (const shortKey in ShortDistance_Escort) {
                    const shortTrip = ShortDistance_Escort[shortKey];
                    const stops = shortTrip.stops;
                    let showStopLatitude;
                    let showStopLongitude;

                    for (const key in stops) {
                      if (stops.hasOwnProperty(key)) {
                        const stop = stops[key];
                        showStopLatitude = stop.stopLatitude;
                        showStopLongitude = stop.stopLongitude;
                        // console.log("Stop latitude:", stop.stopLatitude);
                        // console.log("Stop longitude:", stop.stopLongitude);
                      }
                    }

                    // console.log("showStopLatitude", showStopLatitude);
                    // console.log("showStopLongitude", showStopLongitude);

                    index += 1;
                    newRows.push({
                      Sr: index,
                      Name: user.userName,
                      Email: user?.userEmail,
                      Mobile: user?.userPhone,
                      VehicleReg: shortTrip.regNo || "N/A",
                      VehicleImage: (
                        <img
                          onClick={() => handleImageClick(shortTrip.imgVehicle)}
                          src={shortTrip.imgVehicle}
                          alt="vehicle"
                          style={{ width: "50px", height: "50px", borderRadius: "50%" }}
                        />
                      ),
                      State: user?.state || "Unknown",
                      TripDate: shortTrip.ArrivalDate,
                      IsMoving: (() => {
                        if (shortTrip.Trip_Status === "Moving") {
                          return (
                            <Button
                              variant="contained"
                              className="text-white"
                              sx={{ backgroundColor: "green", color: "white" }}
                            >
                              Running
                            </Button>
                          );
                        } else if (shortTrip.Trip_Status === "Arrived") {
                          return (
                            <Button
                              variant="contained"
                              className="text-black"
                              sx={{ backgroundColor: "yellow", color: "white" }}
                            >
                              Arrived
                            </Button>
                          );
                        } else {
                          return (
                            <Button
                              variant="contained"
                              className="text-white"
                              sx={{ backgroundColor: "red", color: "white" }}
                            >
                              Stopped
                            </Button>
                          );
                        }
                      })(),
                      TripTime: shortTrip.TripTime,
                      TripEndTime: shortTrip?.ArrivalTime || "N/A",
                      TripType: <h5>Short Distance</h5>,
                      StartRide: (
                        <Link
                          to={`/locateSos/${shortTrip.LiveLatitude}/${shortTrip.LiveLongitude}`}
                        >
                          Track
                        </Link>
                      ),
                      EndRide: (
                        <Link to={`/locateSos/${showStopLatitude}/${showStopLongitude}`}>
                          Track
                        </Link>
                      ),
                    });
                  }
                }
              }
            }
          }
        }

        // Fetch Virtual Travel Guard from API
        try {
          const virtualRes = await apiClient.get("/virtual-travel-guard", { params: { page: 1, limit: 500 } });
          const records = Array.isArray(virtualRes?.data) ? virtualRes.data : [];
          records.forEach((record) => {
            const payload = record?.payload || {};
            const state = record?.state || payload?.state || record?.userState || payload?.userState || "Unknown";
            
            if (useradmin && getUserState !== "" && getUserState !== "All State" && state !== getUserState) return;
            if (!useradmin && state !== getAdminState) return;
            
            newRows.push({
              Name: payload?.userName || record?.userName || payload?.Name || record?.Name || "Unknown",
              Email: payload?.userEmail || "N/A",
              Mobile: payload?.userPhone || payload?.PhoneNumber || "N/A",
              VehicleReg: payload?.VehicleNumber || payload?.vehicleNumber || "N/A",
              VehicleImage: <img onClick={() => handleImageClick(payload?.userImage || record?.userImage)} src={payload?.userImage || record?.userImage} style={{ width: "50px", height: "50px", borderRadius: "50%" }} alt="vehicle" />,
              State: state,
              TripDate: payload?.TripDate || payload?.Date || "N/A",
              IsMoving: <Button variant="contained" sx={{ backgroundColor: payload?.tracking ? "green" : "red", color: "white" }}>{payload?.tracking ? "Running" : "Stopped"}</Button>,
              TripType: <h5>Virtual Travel Guard</h5>,
              StartRide: payload?.currentLocTxt || payload?.currentLoc || "N/A",
              EndRide: Array.isArray(payload?.destLocTxt) ? payload?.destLocTxt.join(", ") : (payload?.destLocTxt || payload?.destLoc || "N/A"),
            });
          });
        } catch (err) {
          console.error("Error fetching Virtual Travel Guard", err);
        }

        // Fetch Cargo Escort from API
        try {
          const cargoRes = await apiClient.get("/cargo-escort?page=1&limit=500");
          const cargoRecords = Array.isArray(cargoRes?.data) ? cargoRes.data : (Array.isArray(cargoRes?.cargoEscorts) ? cargoRes.cargoEscorts : (Array.isArray(cargoRes?.result) ? cargoRes.result : (Array.isArray(cargoRes) ? cargoRes : [])));
          cargoRecords.forEach((cargo) => {
            const state = cargo.state || "Unknown";
            if (cargo.state) {
              if (useradmin && getUserState !== "" && getUserState !== "All State" && state !== getUserState) return;
              if (!useradmin && state !== getAdminState) return;
            }

            newRows.push({
              Name: cargo.requesterName || cargo.RequesterName || cargo.name || "N/A",
              Email: cargo.requesterEmail || cargo.RequesterEmail || cargo.email || "N/A",
              Mobile: cargo.requesterPhone || cargo.RequesterPhoneNo || cargo.phoneNumber || "N/A",
              VehicleReg: cargo.vehicleNumber || cargo.VehicleNumber || cargo.vehicle || "N/A",
              VehicleImage: "N/A",
              State: state,
              TripDate: cargo.departureDate || cargo.DepartureDate || "N/A",
              IsMoving: <Button variant="contained" sx={{ backgroundColor: cargo.status === "ACTIVE" || cargo.status === "ADMIN_APPROVED" ? "green" : "red", color: "white" }}>{cargo.status || "N/A"}</Button>,
              TripType: <h5>Cargo Escort</h5>,
              StartRide: cargo.pickupLocation || cargo.PickupLocation || cargo.from || "N/A",
              EndRide: cargo.deliveryLocation || cargo.DeliveryLocation || cargo.to || "N/A",
            });
          });
        } catch (err) {
          console.error("Error fetching Cargo Escort", err);
        }

        // Set Sr number properly
        newRows.forEach((row, idx) => row.Sr = idx + 1);

        setRows(newRows); // Set the combined data for both short and long trips, plus API trips
    } catch (error) {
      //  console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (!user) {
      navigate("/authentication/sign-in");
    }
    getData();
  }, [allData, getUserState]);

  useEffect(() => {
    if (searchTxt == "") {
      getData();
    }

    if (searchTxt) {
      const filteredRows = rows.filter((row) => {
        const { Phone, Name } = row;
        const searchWithoutPlus = searchTxt.replace(/\+/g, ""); // Remove plus sign
        const phoneWithoutPlus = Phone?.replace(/\+/g, ""); // Remove plus sign

        return (
          phoneWithoutPlus?.startsWith(searchWithoutPlus) ||
          Name?.toLowerCase().startsWith(searchWithoutPlus.toLowerCase())
        );
      });

      setRows(filteredRows);
    }
  }, [searchTxt]);

  return (
    <DashboardLayout>
      <MDBox pt={6} pb={3}>
        <Box display="flex" justifyContent="flex-end" alignItems="center" mb={5} px={2}>
          <TextField
            label="Search by name, email and mobile"
            variant="outlined"
            size="small"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            sx={{ width: 300 }}
          />
        </Box>
        <Grid container spacing={6} style={{ position: "relative", minHeight: "60vh" }}>
          {loading ? (
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center", // Ensure horizontal centering
              }}
            >
              Loading...
            </div>
          ) : (
            <>
              <Grid item xs={12}>
                <Card>
                  <MDBox
                    mx={2}
                    mt={-3}
                    py={3}
                    px={2}
                    variant="gradient"
                    bgColor="info"
                    borderRadius="lg"
                    coloredShadow="info"
                  >
                    <ToastContainer />
                    <MDTypography variant="h6" color="white">
                      {checkSuperAdmin
                        ? getUserState === ""
                          ? "All State "
                          : `${getUserState} State `
                        : `${adminState} State `}
                      Track Trip History
                    </MDTypography>
                  </MDBox>

                  <MDBox pt={3}>
                    {rows.length > 0 ? (
                      <DataTable
                        table={{
                          columns,
                          rows: rows.filter((row) => {
                            const search = searchTerm.toLowerCase().trim();
                            const name = row?.Name?.toLowerCase() || "";
                            const email = row?.Email?.toLowerCase() || "";
                            const mobile = row?.mobile?.toLowerCase() || "";

                            return (
                              name.includes(search) ||
                              email.includes(search) ||
                              mobile.includes(search)
                            );
                          }),
                        }}
                        isSorted={false}
                        entriesPerPage={false}
                        showTotalEntries={false}
                        noEndBorder
                      />
                    ) : (
                      <EmptyData />
                    )}
                  </MDBox>
                </Card>
                <ImageModal
                  onClickImageData={onClickImageData}
                  onClose={onClose}
                  isModalOpen={isModalOpen}
                />
              </Grid>
            </>
          )}
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default TripMonitor;
